function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Resellers",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Network-Index-expanded",
  transform: "translate(-318.000000, -178.000000)",
  fill: "#76B83F",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M341.563852,199.492894 L336.620335,194.618362 C338.011384,192.870917 338.849908,190.673352 338.849908,188.279106 C338.849908,182.602132 334.182654,178 328.424954,178 C322.667254,178 318,182.602132 318,188.279106 C318,193.95608 322.667254,198.558211 328.424954,198.558211 C330.678866,198.558211 332.758746,197.84601 334.465001,196.646967 L339.457198,201.569979 C340.038932,202.14334 340.980902,202.14334 341.562635,201.569979 C342.145585,200.996497 342.145585,200.066255 341.563852,199.492894 Z M334.213079,193.449559 C334.013489,193.520719 333.824851,193.624999 333.665422,193.782799 C333.51938,193.92752 333.409849,194.09492 333.336828,194.273361 C331.99446,195.344483 330.28577,195.988405 328.424954,195.988405 C324.106983,195.988405 320.60563,192.536836 320.60563,188.279106 C320.60563,184.021375 324.106983,180.569806 328.424954,180.569806 C332.742924,180.569806 336.243061,184.021375 336.243061,188.279106 C336.243061,190.270991 335.470256,192.080955 334.213079,193.449559 Z",
  id: "Shape"
})));

function SvgGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.9ab21ea0.svg";
export { ForwardRef as ReactComponent };